(function () {
  // 5kg bags that must not stay in cart unless customer is Intercompany
  var RESTRICTED_VARIANT_IDS = [
    44601255985420, // legacy 5kg Tin (House)
    65995972673804, // El Cipres - 5kg Espresso
    65974538436876, // Tempisque - 5kg Espresso
    62082130870540  // La Palma - 5kg Espresso
  ];

  if (sessionStorage.getItem('fe_intercompany_error')) {
    sessionStorage.removeItem('fe_intercompany_error');

    document.addEventListener('DOMContentLoaded', function () {
      var banner = document.createElement('div');
      banner.innerHTML =
        '<strong>Access restricted.</strong> The 5kg option is available for ' +
        'intercompany accounts only. Contact ' +
        '<a href="mailto:wholesale@fiveelephant.com" style="color:inherit">' +
        'wholesale@fiveelephant.com</a> to place this order.';
      banner.style.cssText =
        'background:#fff3cd;border:1px solid #e6b800;padding:14px 18px;' +
        'margin:0 0 20px;border-radius:4px;font-size:14px;line-height:1.6;';

      var target =
        document.querySelector('form[action="/cart"]') ||
        document.querySelector('.cart__form') ||
        document.querySelector('main');

      if (target) target.prepend(banner);
    });
  }

  var tags = window.__feCustomerTags || [];
  var isIntercompany = false;
  for (var i = 0; i < tags.length; i++) {
    var t = String(tags[i] || '').toLowerCase();
    if (
      t === 'intercompany' ||
      t === 'company' ||
      t === 'compania' ||
      t.indexOf('intercompany') !== -1
    ) {
      isIntercompany = true;
      break;
    }
  }
  if (isIntercompany) return;

  var variantIds = window.__feCartVariantIds || [];
  var updates = {};
  var hasRestricted = false;
  for (var j = 0; j < RESTRICTED_VARIANT_IDS.length; j++) {
    var id = RESTRICTED_VARIANT_IDS[j];
    if (variantIds.indexOf(id) !== -1 || variantIds.indexOf(String(id)) !== -1) {
      updates[id] = 0;
      hasRestricted = true;
    }
  }
  if (!hasRestricted) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: updates })
  })
    .then(function (res) {
      if (res.ok) {
        sessionStorage.setItem('fe_intercompany_error', '1');
        window.location.reload();
      }
    })
    .catch(function (err) {
      console.error('[FE gate] Cart update failed:', err);
    });
})();
